import { css } from 'lit';
export const styles = css `
:host(:focus){outline:0}.wrapper{-webkit-backdrop-filter:var(--hds-overlay-blur);backdrop-filter:var(--hds-overlay-blur);background-color:var(--hds-onlightcolor-secondary);bottom:0;height:100%;left:0;position:fixed;right:0;top:0;width:100%;z-index:999}
`;
//# sourceMappingURL=hds-overlay.css.js.map